import { cn } from '@/lib/utils';

interface ProgressIndicatorProps {
  totalSteps: number;
  currentStep: number;
}

/**
 * Dot-based progress indicator for tour steps.
 */
export function ProgressIndicator({ totalSteps, currentStep }: ProgressIndicatorProps) {
  return (
    <div className="flex items-center gap-1.5" role="tablist" aria-label="Tour progress">
      {Array.from({ length: totalSteps }, (_, i) => (
        <div
          key={i}
          role="tab"
          aria-selected={i === currentStep}
          aria-label={`Step ${String(i + 1)} of ${String(totalSteps)}`}
          className={cn(
            'h-1.5 rounded-full transition-all duration-200',
            i === currentStep
              ? 'w-5 bg-primary'
              : i < currentStep
                ? 'w-1.5 bg-primary/50'
                : 'w-1.5 bg-muted-foreground/30'
          )}
        />
      ))}
    </div>
  );
}
